<template>
  <div class="span-attention">
    <div @click.stop="haddleSubscribe" v-if="!filter.attentioned(entityItem.id, _ids_entity(entityType))">
      <slot name="slot1"></slot>
    </div>
    <div v-else @click.stop="haddleCancel">
      <slot name="slot2"></slot>
    </div>
  </div>
</template>
<script>

import filter from 'js/filter'
import { atten_common } from 'js/atten_common'
export default {
  inject: ['login'],
  mixins: [atten_common],
  props: ['entityItem', 'entityType'],
  data() {
    return {
      filter: filter
    }
  },
  methods: {
    haddleSubscribe() {
      if (this.$store.state.user_key) {
        this.addSubscribe(this.entityType, this.entityItem.id, this.subscribeSuccess)
      } else {
        this.login()
      }
    },
    haddleCancel() {
      if (this.$store.state.user_key) {
        let i = this.$store.state.attention.subscribe.findIndex(a => a.sub_type_id == this.entityItem.id)
        if(i > -1) {
          this.deleteSubscribe(this.$store.state.attention.subscribe[i]['id'], this.cancelSuccess)
        }
      } else {
        this.login()
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_l.stylus'
.span-attention
  display inline-block
  vertical-align top
.attention-dropdown
  margin-left 0
.attention_form
  text-align left
</style>
